import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LockIcon, UserPermission } from 'remote/global';

function ViewPermissionsGate({ role, children }: { role: string; children: React.ReactNode }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if ([UserPermission.NO_ACCESS, UserPermission.RESTRICTED].includes(role as UserPermission))
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '1000px',
          gap: 4,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            pt: 4,
            pb: 4,
            pr: 5,
            pl: 5,
            maxWidth: '421px',
            textAlign: 'center',
          }}
        >
          <div style={{ display: 'inline-block' }}>
            <LockIcon />
          </div>
          <Typography
            sx={{
              m: 3,
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '120%',
            }}
          >
            {role === UserPermission.NO_ACCESS && t('ForbiddenView.title')}
            {role === UserPermission.RESTRICTED && t('RestrictedView.title')}
          </Typography>
          <Typography mb={3} variant='body2' maxWidth='350px'>
            {role === UserPermission.NO_ACCESS && t('ForbiddenView.subtitle')}
            {role === UserPermission.RESTRICTED && t('RestrictedView.subtitle')}
          </Typography>
          <Button
            type='submit'
            variant='contained'
            color='primary'
            onClick={() => {
              if (role === UserPermission.NO_ACCESS) navigate(-1);
              if (role === UserPermission.RESTRICTED) navigate('/main/settings/subscription');
            }}
            sx={{ maxWidth: 'max-content' }}
          >
            {role === UserPermission.NO_ACCESS && t('actions.fetch.goBack')}
            {role === UserPermission.RESTRICTED && t('ForbiddenView.goToSubscription')}
          </Button>
        </Box>
      </Box>
    );

  return children;
}

export default ViewPermissionsGate;
